<table class="ir-plugin-table">
  <tr *ngIf="bccBsa?.Label">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ bccBsa.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1"> </span>
      </p>
    </td>
  </tr>
  <tr *ngIf="hasValue()">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationpartybccbsa.done-by' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">
          {{ getProvenanceText() }}
        </span>
      </p>
    </td>
  </tr>
</table>
